/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantVcdsDeploymentApplicationHealth } from './tenantVcdsDeploymentApplicationHealth';
import { VcdsDeploymentCloudProvider } from './vcdsDeploymentCloudProvider';
import { VcdsDeploymentSystemIssue } from './vcdsDeploymentSystemIssue';
import { BasicVcdsDeploymentVersion } from './basicVcdsDeploymentVersion';
import { RolloutTargetTenantSummary } from './rolloutTargetTenantSummary';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsDeploymentStateEnum } from './vcdsDeploymentStateEnum';
import { VcdsDeploymentCommerce } from './vcdsDeploymentCommerce';
import { VcdsDeploymentNetwork } from './vcdsDeploymentNetwork';
import { VcdsDeploymentStats } from './vcdsDeploymentStats';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';
import { VcdsDeploymentInventoryTree } from './vcdsDeploymentInventoryTree';


export interface TenantVcdsDeployment { 
    /**
     * Org Id
     */
    org_id?: string;
    /**
     * Deployment Id
     */
    deployment_id?: string;
    service_type?: ServiceTypeEnum;
    vcds_service_type?: VcdsServiceTypeEnum;
    state?: VcdsDeploymentStateEnum;
    /**
     * Deployment name
     */
    name?: string;
    /**
     * Deployment secondary name
     */
    secondary_name?: string;
    vmware_managed?: boolean;
    discovered?: boolean;
    login_allowed?: boolean;
    cloud_provider?: VcdsDeploymentCloudProvider;
    network?: VcdsDeploymentNetwork;
    version?: BasicVcdsDeploymentVersion;
    commerce?: VcdsDeploymentCommerce;
    inventory?: VcdsDeploymentInventoryTree;
    personas?: Array<string>;
    /**
     * Created by user
     */
    created_by?: string;
    /**
     * Deployment creation date time
     */
    created_time?: Date;
    /**
     * Deleted by user
     */
    deleted_by?: string;
    /**
     * Deployment deletion date time
     */
    deleted_time?: Date;
    /**
     * Last reported date time of inventory, usage or health from agent
     */
    last_reported_time?: Date;
    /**
     * Deployment last updated date time
     */
    last_updated_time?: Date;
    stats?: VcdsDeploymentStats;
    system_issues?: Array<VcdsDeploymentSystemIssue>;
    tasks?: Array<string>;
    health?: TenantVcdsDeploymentApplicationHealth;
    rollout_upgrade_summary?: Array<RolloutTargetTenantSummary>;
}
export namespace TenantVcdsDeployment {
}


